exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu[data-v-03b05fd0] {\n  cursor: pointer;\n  position: absolute;\n  z-index: 100;\n  background-color: white;\n  transition-duration: 400ms;\n}\n.menu img[data-v-03b05fd0] {\n  width: 100%;\n  vertical-align: middle;\n}\n.menu-child > div[data-v-03b05fd0] {\n  position: absolute;\n  z-index: 99;\n}\n.menu-child > div img[data-v-03b05fd0] {\n  width: 100%;\n  vertical-align: middle;\n}\n#toggleMenu[data-v-03b05fd0] {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}\n", ""]);

// exports
